import { Button, Col, Collapse, Divider, Empty, Modal, Spin, message, Tag, Card, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import dayjs from 'dayjs';
import { baseUrlAREA, CHECK_CONTNO, HEADERS_BASIC } from '../../../API/apiUrlsNew';
// import { orange } from '@mui/material/colors';

// const { Panel } = Collapse;

function CheckCONTNO({ open, close, data }) {
    const [loading, setLoading] = useState(false);
    const [dataCOTNO, setdataCOTNO] = useState([]);
    const [workDemandGuaranter, setWorkDemandGuaranter] = useState([]);
    const [workCancelContract, setWorkCancelContract] = useState([]);
    const [letterCarRepurchase, setLetterCarRepurchase] = useState([]);

    useEffect(() => {
        if (data) {
            loadData(data)
        }
    }, [])

    const loadData = async (value) => {
        setLoading(true);
        await axios.get(baseUrlAREA + `${CHECK_CONTNO}/${value}`, { headers: HEADERS_BASIC })
            .then((res) => {
                if (res.status === 200) {
                    setdataCOTNO(res.data)
                    setLetterCarRepurchase(res.data.letterCarRepurchase || [])
                    setWorkCancelContract(res.data.workCancelContract || [])
                    setWorkDemandGuaranter(res.data.workDemandGuaranter || [])
                    setLoading(false);
                    message.success("โหลดข้อมูลสำเร็จ");
                }
            })
            .catch((err) => {
                setLoading(false);
                message.error("โหลดข้อมูลไม่สำเร็จ !! ");
                console.log(err);
            });
    }

    const handleClose = () => {
        close(false)
    }

    const renderItemDemandGuarantor = (item) => {

        const customerType =
            item.customerTypeId === 0
                ? <Tag color="blue">ผู้เช่าซื้อ</Tag>
                : <Tag color="orange">ผู้ค้ำประกัน {item.customerTypeId}</Tag>;

        const status =
            item.statusReply === 1
                ? <Tag color="green">ตอบกลับ</Tag>
                : item.statusReply === 2
                    ? <Tag color="red">ตีกลับ</Tag>
                    : <Tag>ไม่ระบุ</Tag>;

        return (
            <Card
                size="small"
                style={{
                    borderRadius: 10,
                    background: "#fafafa"
                }}
            >
                <Row gutter={[16, 10]}>

                    <Col span={24}>
                        <b style={{ fontSize: 15 }}>
                            {item.customerFullName}
                        </b>{" "}
                        {customerType}
                    </Col>

                    <Col span={12}>
                        <b>EMS ไป :</b> {item.parcelNo || "-"}
                    </Col>

                    <Col span={12}>
                        <b>EMS กลับ :</b> {item.parcelNoResponse || "-"}
                    </Col>

                    <Col span={12}>
                        <b>รอบ :</b> <Tag color={"orange"}>{dayjs(item.roundDate).format("DD/MM/YYYY")}</Tag>
                    </Col>

                    <Col span={12}>
                        <b>สร้างเมื่อ :</b>{" "}
                        <Tag color={"blue"}>{dayjs(item.createdAt).format("DD/MM/YYYY HH:mm")}</Tag>
                    </Col>

                    <Col span={12}>
                        <b>สถานะ :</b> {status}
                    </Col>

                    <Col span={12}>
                        <b>วันที่จดหมายถึงบริษัท :</b>{" "}
                        {item.dateReply
                            ? <Tag color={"green"}>{dayjs(item.dateReply).format("DD/MM/YYYY HH:mm")}</Tag>
                            : <Tag color={"green"}>-</Tag>}
                    </Col>

                </Row>
            </Card>
        );
    };

    const renderItemWorkCancelContract = (item) => {

        const customerType =
            item.customerTypeId === 0
                ? <Tag color="blue">ผู้เช่าซื้อ</Tag>
                : <Tag color="orange">ผู้ค้ำประกัน {item.customerTypeId}</Tag>;

        const status =
            item.statusReply === 1
                ? <Tag color="green">ตอบกลับ</Tag>
                : item.statusReply === 2
                    ? <Tag color="red">ตีกลับ</Tag>
                    : <Tag>-</Tag>;

        return (
            <Card
                size="small"
                style={{
                    borderRadius: 10,
                    background: "#fafafa"
                }}
            >
                <Row gutter={[16, 10]}>

                    <Col span={24}>
                        <b style={{ fontSize: 15 }}>
                            {item.customerFullName}
                        </b>{" "}
                        {customerType}
                    </Col>

                    <Col span={12}>
                        <b>EMS ไป :</b> {item.parcelNo || "-"}
                    </Col>

                    <Col span={12}>
                        <b>EMS กลับ :</b> {item.parcelNoResponse || "-"}
                    </Col>

                    <Col span={12}>
                        <b>รอบ :</b> <Tag color={"orange"}>{dayjs(item.datetime).format("DD/MM/YYYY")}</Tag>
                    </Col>

                    <Col span={12}>
                        <b>สร้างเมื่อ :</b>{" "}
                        <Tag color={"blue"}>{dayjs(item.createdDate).format("DD/MM/YYYY HH:mm")}</Tag>
                    </Col>

                    <Col span={12}>
                        <b>สถานะ :</b> {status}
                    </Col>

                    <Col span={12}>
                        <b>วันที่จดหมายถึงบริษัท :</b>{" "}
                        {item.dateReply
                            ? <Tag color={"green"}>{dayjs(item.dateReply).format("DD/MM/YYYY HH:mm")}</Tag>
                            : <Tag color={"green"}>-</Tag>}
                    </Col>

                </Row>
            </Card>
        );
    };

    const renderItemLetterCarRepurchase = (item) => {

        const customerType =
            item.GARNO === 0
                ? <Tag color="blue">ผู้เช่าซื้อ</Tag>
                : <Tag color="orange">ผู้ค้ำประกัน {item.GARNO}</Tag>;

        const status =
            item.statusReply === 1
                ? <Tag color="green">ตอบกลับ</Tag>
                : item.statusReply === 2
                    ? <Tag color="red">ตีกลับ</Tag>
                    : <Tag>-</Tag>;

        return (
            <Card
                size="small"
                style={{
                    borderRadius: 10,
                    background: "#fafafa"
                }}
            >
                <Row gutter={[16, 8]}>
                    <Col span={24}>
                        <b style={{ fontSize: 15 }}>
                            {item.customerFullName}
                        </b>{" "}
                        {customerType}
                    </Col>

                    <Col span={12}>
                        <b>EMS ไป :</b> {item.parcelNo || "-"}
                    </Col>

                    <Col span={12}>
                        <b>EMS กลับ :</b> {item.parcelNoResponse || "-"}
                    </Col>

                    <Col span={12}>
                        <b>รอบ :</b> <Tag color={"orange"}>{dayjs(item.roundDate).format("DD/MM/YYYY")}</Tag>
                    </Col>

                    <Col span={12}>
                        <b>สร้างเมื่อ :</b>{" "}
                        {item.roundDate &&
                            dayjs(item.roundDate).isValid() &&
                            dayjs(item.roundDate).year() > 1900 ? (
                            <Tag color="green">
                                {dayjs(item.roundDate).format("DD/MM/YYYY HH:mm")}
                            </Tag>
                        ) : (
                            <Tag color="green">-</Tag>
                        )}

                    </Col>

                    <Col span={12}>
                        <b>สถานะ :</b> {status}
                    </Col>

                    <Col span={12}>
                        <b>วันที่จดหมายถึงบริษัท :</b>{" "}
                        {item.dateReply &&
                            dayjs(item.dateReply).isValid() &&
                            dayjs(item.dateReply).year() > 1900 ? (
                            <Tag color="green">
                                {dayjs(item.dateReply).format("DD/MM/YYYY HH:mm")}
                            </Tag>
                        ) : (
                            <Tag color="green">-</Tag>
                        )}
                    </Col>
                </Row>
            </Card>
        );
    };

    return (
        <Modal
            open={open}
            // onCancel={handleClose}
            closable={false}
            footer={null}
            title={data}
            width={800}
        >
            <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
                <Collapse
                    style={{ marginBottom: 16 }}
                    items={[
                        {
                            key: "1",
                            label: (
                                <span style={{ fontWeight: 600, fontSize: 16 }}>
                                    📬 จดหมายบอกกล่าวคนค้ำ ({workDemandGuaranter?.length || 0})
                                </span>
                            ),
                            children: (
                                workDemandGuaranter && workDemandGuaranter.length > 0 ? (
                                    <Collapse
                                        accordion
                                        items={workDemandGuaranter.map((item, index) => ({
                                            key: index,
                                            label: (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        width: "100%",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <div>
                                                        <div style={{ fontWeight: 600 }}>
                                                            {item.customerFullName}
                                                        </div>

                                                        <div style={{ fontSize: 13, color: "#888" }}>
                                                            รอบ {dayjs(item.roundDate).format("DD/MM/YYYY")}
                                                        </div>
                                                    </div>
                                                </div>
                                            ),
                                            children: renderItemDemandGuarantor(item),
                                        }))}
                                    />
                                ) : (
                                    <Empty description="ไม่มีข้อมูล" />
                                )
                            )
                        }
                    ]}
                />
                <Collapse
                    style={{ marginBottom: 16 }}
                    items={[
                        {
                            key: "2",
                            label: (
                                <span style={{ fontWeight: 600, fontSize: 16 }}>
                                    📑 จดหมายบอกเลิกสัญญา ({workCancelContract?.length || 0})
                                </span>
                            ),
                            children: (
                                workCancelContract && workCancelContract.length > 0 ? (
                                    <Collapse
                                        accordion
                                        items={workCancelContract.map((item, index) => ({
                                            key: index,
                                            label: (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        width: "100%",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <div>
                                                        <div style={{ fontWeight: 600 }}>
                                                            {item.customerFullName}{" "}
                                                            {item.customerTypeId === 0 ? (
                                                                <Tag color="blue">ผู้เช่าซื้อ</Tag>
                                                            ) : (
                                                                <Tag color="orange">
                                                                    ผู้ค้ำประกัน {item.customerTypeId}
                                                                </Tag>
                                                            )}
                                                        </div>

                                                        <div style={{ fontSize: 13, color: "#888" }}>
                                                            รอบ {dayjs(item.datetime).format("DD/MM/YYYY")}
                                                        </div>
                                                    </div>
                                                </div>
                                            ),
                                            children: renderItemWorkCancelContract(item),
                                        }))}
                                    />
                                ) : (
                                    <Empty
                                        description="ไม่มีข้อมูล"
                                        style={{ margin: "20px 0" }}
                                    />
                                )
                            )
                        }
                    ]}
                />
                <Collapse
                    style={{ marginBottom: 16 }}
                    items={[
                        {
                            key: "3",
                            label: (
                                <span style={{ fontWeight: 600, fontSize: 16 }}>
                                    📄 จดหมายซื้อรถคืน ({letterCarRepurchase?.length || 0})
                                </span>
                            ),
                            children: (
                                letterCarRepurchase && letterCarRepurchase.length > 0 ? (
                                    <Collapse
                                        accordion
                                        items={letterCarRepurchase.map((item, index) => ({
                                            key: index,
                                            label: (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        width: "100%",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <div>
                                                        <div style={{ fontWeight: 600 }}>
                                                            {item.customerFullName}{" "}
                                                            {item.GARNO === 0 ? (
                                                                <Tag color="blue">ผู้เช่าซื้อ</Tag>
                                                            ) : (
                                                                <Tag color="orange">
                                                                    ผู้ค้ำประกัน {item.GARNO}
                                                                </Tag>
                                                            )}
                                                        </div>

                                                        <div style={{ fontSize: 13, color: "#888" }}>
                                                            รอบ {dayjs(item.roundDate).format("DD/MM/YYYY")}
                                                        </div>
                                                    </div>
                                                </div>
                                            ),
                                            children: renderItemLetterCarRepurchase(item),
                                        }))}
                                    />
                                ) : (
                                    <Empty
                                        description="ไม่มีข้อมูล"
                                        style={{ margin: "20px 0" }}
                                    />
                                )
                            )
                        }
                    ]}
                />
                <Divider />
            </Spin>
            <Col span={24} style={{ textAlign: "end" }}>
                <Button
                    type='primary'
                    danger
                    onClick={handleClose}>
                    ปิด
                </Button>
            </Col>
        </Modal>
    )
}

export default CheckCONTNO